import { FetchApiResponse } from "redux/types";

export enum OneViewReportReduxTypes {
    ONE_VIEW_REPORT = "@@auth/ONE_VIEW_REPORT",
    ONE_VIEW_REPORT_SUCCESS = "@@auth/ONE_VIEW_REPORT_SUCCESS",
    ONE_VIEW_REPORT_ERROR = "@@auth/ONE_VIEW_REPORT_ERROR"
}

export type OneViewReportActionDispatch = {
    type: | OneViewReportReduxTypes.ONE_VIEW_REPORT;
    payload: any;
}

export type OneViewReportReducerDispatch = {
    type: | OneViewReportReduxTypes.ONE_VIEW_REPORT
    | OneViewReportReduxTypes.ONE_VIEW_REPORT_SUCCESS
    | OneViewReportReduxTypes.ONE_VIEW_REPORT_ERROR

    payload: {
        data?: FetchApiResponse<OneViewReport>
        error?: string
    }
}

export type OneViewReport = {
    id: string,
    financierId: string,
    userId: string,
    type: string,
    status: number,
    updatedOn: string;
    createdOn: string;
}

export type OneViewReportRequest = {
    payload: {},
    type: string
}

export type CreateOneViewReportReduxState = {
    loading?: boolean
    data?: {},
    error?: string | null;
}